import { render, staticRenderFns } from "./MonitoramentoPrada.vue?vue&type=template&id=1b67839a&scoped=true&lang=pug"
import script from "./MonitoramentoPrada.vue?vue&type=script&lang=js"
export * from "./MonitoramentoPrada.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoPrada.vue?vue&type=style&index=0&id=1b67839a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b67839a",
  null
  
)

export default component.exports